<template>
  <transition-group name="fade-arquivos">
    <ArquivoBase
      v-for="arquivo in listaArquivos"
      :key="arquivo.objetoArquivo.id"
      :tipoArquivo="arquivo.tipoArquivo"
      :objetoArquivo="arquivo.objetoArquivo"
      :barraProgresso="arquivo.barraProgresso"
      @baixar-arquivo="uuid => $emit('baixar-arquivo', uuid)"
      @arquivo-para-descricao="carregarArquivoParaDescricao"
    />
  </transition-group>
</template>

<script>
import ArquivoBase from "./TiposArquivos/ArquivoBase";

export default {
  components: {
    ArquivoBase
  },
  props: {
    listaArquivos: {
      type: Array,
      default: () => [
        // {
        //   tipoArquivo: "",
        //   objetoArquivo: {
        //     nomeArquivo: "",
        //     tamanhoArquivo: 0,
        //     dataEnvio: "",
        //     dataAlteracao: "",
        //     dataAlteracao: "",
        //     barraProgresso: 0,
        //     descricao: "",
        //   },
        //   barraProgresso: 0
        // }
      ]
    }
  },
  methods: {
    carregarArquivoParaDescricao(arquivo) {
      console.log("listas_arquivo_vue", arquivo);
      this.$emit("arquivo-para-descricao", arquivo);
    }
  }
};
</script>

<style lang="scss" scoped></style>
